import { TributeVideosComponent } from '@/pages/Event/components/TributeVideos';

type TributeVideosProps = {
  id: string;
  organizationPermissions?: string[];
};

export const TributeVideos = ({ id, organizationPermissions }: TributeVideosProps) => {
  return <TributeVideosComponent id={id} organizationPermissions={organizationPermissions} />;
};
